import { ApiRes } from '@/types/api'
import { StripeSetupIntentReq, StripeSetupIntentRes } from '@/types/stripe'
import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

const endpoint = '/api/v1/stripe'

export function useStripeSetupIntent() {
  const { mutateAsync: onCreate, isPending } = useMutation({
    mutationKey: ['stripe.setup-intent.generate-secret'],
    mutationFn: async (req: StripeSetupIntentReq) => {
      const res = await axios.post<ApiRes<StripeSetupIntentRes>>(
        `${endpoint}/setup-intents`,
        req,
      )

      return res.data
    },
  })

  return { onCreate, isLoading: isPending }
}
